import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface ChipProps {
  children: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

/** Odabrani chip: 2px accent rub + accent-light pozadina (design-system.md, sekcija 4). */
export function Chip({ children, selected = false, onClick, disabled, className }: ChipProps) {
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag
      {...(onClick ? { type: 'button' as const, onClick, 'aria-pressed': selected } : {})}
      disabled={onClick ? disabled : undefined}
      className={cx(
        'inline-flex items-center gap-2 rounded-md px-[18px] py-[14px] text-[14.5px]',
        'transition-colors duration-200 text-left',
        selected
          ? 'border-2 border-accent bg-accent-light text-ink'
          : // Neodabrani chip je i dalje kontrola; `line` daje 1,28:1 i ne vidi se.
            'border border-line-control bg-surface text-ink hover:border-accent-dark',
        disabled && 'opacity-40 pointer-events-none',
        className,
      )}
    >
      {children}
    </Tag>
  );
}
